import { render, staticRenderFns } from "./DashboardPreview.vue?vue&type=template&id=8ce573d6&scoped=true&"
import script from "./DashboardPreview.vue?vue&type=script&lang=js&"
export * from "./DashboardPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce573d6",
  null
  
)

export default component.exports